<template>
    
<div class="container">
     
  <div v-if="loading==true" class="container">
    <div class="text-center">
      <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
    </div>
  </div>  <!-- closing the loading container-->


    <div v-if="myReservations.length==0 && !loading">
    <div class="col-sm-12">
        <h3 class="text-center" style="margin-top:0px;">No bookings available, visit <a href="javascript:;" @click="goSearchSitters()"><strong>Search Sitters</strong></a> to book a sitter now.</h3>
        </div>
    </div>
            
                <div v-if="myReservations.length>0 && !loading" class="hidden-lg hidden-md">
                <button @click="switchCollapse()" class="hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title" data-toggle="collapse" data-target="#filterSort"> <i class="fa fa fa-navicon" /> &nbsp {{summaryComp}}</button>
                <div class=" hidden-md hidden-lg collapse" id="filterSort" style="margin-left:0px;padding-left:0px; margin-right:0px; padding-right:0px">
                    
                    <div class="reservationSummary">
                        <div >
                        
                        <h3 style="margin-top:5px;"> <i class="fa fa-cog" /> Filters and Sort</h3>
                        <div class="row">
                                <div class="col-xs-12">
                                <div >
                                    <div class="col-xs-12 remove-margins">
                                    <label >
                                    <input type="radio" v-model="sort" value="0"> <span> Submitted Date</span>
                                    </label>
                                    </div>
                                    <div class="col-xs-12 remove-margins">
                                    <label >
                                    <input type="radio" v-model="sort" value="1"><span> Start Date</span>
                                    </label>
                                    </div>
                                    <div class="col-xs-12 remove-margins">
                                    <label >
                                    <input type="radio" v-model="sort" value="2"><span> Total Price</span>
                                    </label>
                                    </div>
                                </div>

                                </div>
                            </div>
                        
                        <button v-if="!hidden" @click="hideCompleted()" class="btn btn-block btn-default">Hide Completed or Expired</button>
                        <button v-else @click="showCompleted()" class="btn btn-block btn-default">Show Completed or Expired</button>
                        
                    </div>
                    </div>
                    
                </div>
                
                <br>
                
            </div>
            <div v-if="myReservations.length>0 && !loading" class="hidden-xs hidden-sm col-sm-4 col-xs-12 ">

                <div class="wrapper">
                      <h3 style="margin-top:5px;"> <i class="fa fa-cog" /> Filters and Sort</h3>
                      <div class="row">
                            <div class="col-xs-12">
                            <div >
                                <div class="col-xs-12 remove-margins">
                                <label >
                                <input  type="radio" v-model="sort" value="0"> <span> Submitted Date</span>
                                </label>
                                </div>
                                <div class="col-xs-12 remove-margins">
                                <label >
                                <input type="radio" v-model="sort" value="1"><span> Start Date</span>
                                </label>
                                </div>
                                <div class="col-xs-12 remove-margins">
                                <label >
                                <input type="radio" v-model="sort" value="2"><span> Total Price</span>
                                </label>
                                </div>
                            </div>

                            </div>
                        </div>
                    <button v-if="!hidden" @click="hideCompleted()" class="btn btn-block btn-info">Hide Completed or Expired</button>
                    <button v-else @click="showCompleted()" class="btn btn-block btn-info">Show Completed or Expired</button>
                </div>
            </div>
            <div v-if="myReservations" class="col-sm-12 col-md-8 col-xs-12 pull-right">
            <div class="row">
                <div class="wrapper " v-for="(reservation,index) in sortedReservationsComp" :key="reservation.ReservationId">
                <div class="media-body">
                        <div class="media-left" style="padding-top:10px;">
            
                        <img  @click="goSitter(reservation.SitterId)" :src="reservation.SitterProfilePic" alt="" class="media-object img-responsive img-circle" style="min-width:30px; min-height:30px; border: 1px solid #c3c3c3; cursor:pointer" height="30" width="30"></img>
                 </div>
            
                <div class="media-left" style="padding-top:10px;">
                    <a href="javascript:;" @click="goSitter(reservation.SitterId)" class="media-heading main-name" style="padding-bottom:0px;margin-bottom:3px;"> <strong> {{reservation.SitterName}}</strong></a>
                </div>
                <div class="media-bottom" >
                <p style="padding-top:0px;margin-top:0px;padding-bottom:0px;margin-bottom:0px;" class="small text-muted"> Booking number: <strong> {{reservation.BookingNumber}} </strong></p>
                <p style="padding-top:0px;margin-top:0px;padding-bottom:0px;margin-bottom:0px;" class="small text-muted"><strong>{{startDateComp(reservation)}}</strong> </span> <span>To <strong>{{endDateComp(reservation)}}</strong></span></p>
                <p style="padding-top:0px;margin-top:0px;padding-bottom:0px;margin-bottom:0px;" class="small text-muted"> Submitted: <strong> {{sentDate(reservation.SubmittedDate)}} </strong></p>
                <p style="padding-top:0px;margin-top:0px;padding-bottom:0px;margin-bottom:0px;" class="small text-success"><strong> Starts</strong> <strong> {{startDate(reservation.StartDate)}} </strong></p>
                <p style="padding-top:0px;margin-top:0px;padding-bottom:0px;margin-bottom:0px;" class="small text-muted"> Total price: <strong class="text-success"> {{customerTotalPrice(reservation.TotalPrice)}} </strong> {{currencyComp}}</p>
                <h5 class="alert text-muted" :class="reservation.StatusClass"> <strong>Status: </strong> {{reservation.CustomerStatus}}</h5>
                </div>
                </div>
                <div class="media-bottom" style="overflow:hidden;">
                        <button class="btn btn-success btn-block" @click="goToReservation(reservation)">Go to Booking </button>
                        <button class="btn btn-warning btn-block" v-if="bookingRemovable(reservation)" @click="removeBooking(reservation); reservation.IsCustomerRemoved=true"><i class="fa fa-trash-o"></i> Remove from Bookings </button>
                        <button class="btn btn-warning btn-block" disabled v-if="reservation.IsCustomerRemoved==true">Removing..</button>
                </div>
                
             </div>
         </div>
     </div>
    </div>
    
</div>

</template>

<script>


import store from '../../../../data/store.js'
const API_URL = "https://www.dupaws.com/services/"
export default {
    name: 'my-reservations', 
    data() {
        return {
          myReservations:'',
          hidden: false,
          loading:true,
          tempReservations: '',
          sort: 0
          }
    },
    methods:{
        switchCollapse(){
            if (this.summaryCollapse==true)
                this.summaryCollapse=false
            else
                this.summaryCollapse=true
        },
        goSearchSitters: function(){
            this.$router.push({path: '/findsitters'})
        },
        bookingRemovable: function(reservation){
            var self = this
            var now = moment()
            var endDate = moment(reservation.OriginalEndDate)

            if (reservation.IsCustomerRemoved == true)
                return false
            if (reservation.IsSitterRejected == true || reservation.IsCustomerCancelled == true)
                return true
            if (endDate <= now)
                return true
            else    
                return false
        },
        showCompleted: function(){
            this.hidden = false
            this.myReservations = this.tempReservations
        },
        hideCompleted: function(){
            var self = this
            self.hidden = true;
            var now = moment()
            self.tempReservations = self.myReservations.slice();
            
            $.each(self.myReservations, function(index,reservation){
                if (reservation!=null)
                {
                    var originalEndDate = moment(reservation.OriginalEndDate)
                    var endDate = moment(reservation.EndDate)
                    if (endDate <= now || originalEndDate<=now || reservation.IsCustomerCancelled || reservation.IsSitterRejected)
                        {
                            self.myReservations.splice(index, 1)
                        }
                }
            })
            
            
        },
        removeBooking: function(reservation){
          var self = this
          $.ajax({
            type: 'POST',
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
            },
            url: API_URL + "api/customer/removeBooking/" + reservation.ReservationId,
            dataType: "json",
            crossDomain: true,
            contentType: "application/json; charset=utf-8",
            success: function(data) {
                    setTimeout(function(){
                    const index = self.myReservations.findIndex(t => t.ReservationId === reservation.ReservationId);
                    self.myReservations.splice(index, 1)
                  },100);},
            error: function(data, status, error) {
            }
        })
        },
        customerTotalPrice: function(totalPrice){
            return  (totalPrice).toFixed(2)
       },
       startDateComp: function(reservation){
            return moment(reservation.StartDate).format('DD MMM YYYY')
        },
        endDateComp: function(reservation){
            return moment(reservation.EndDate).format('DD MMM YYYY')
        },
        sentDate: function(date){
            return moment(date).fromNow()
        },
       startDate: function(date,bookingNumber){
            var currentDate = moment()
            var sittingDate = moment(date)
            var difference = sittingDate.diff(currentDate, 'hours')
            if (difference<-25){
                return 'Already Started'
            }
            if (difference <0 && difference >=-24)
                return 'Today'
            else if (difference <=24)
                return moment(date).fromNow()
            else
                return moment(new Date()).to(date)
        },
        goSitter: function(sitterId){
            this.$router.push({path: '/sitter/' + sitterId})
        },
        goToReservation: function(reservation){
            this.$router.push({name: 'view-reservation', params: {reservationId: reservation.ReservationId}})
        },
        loadData: function(){
         var self = this
         $.ajax({
            type: 'GET',
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
            },
            url: API_URL + "api/customer/getMyReservations",
            dataType: "json",
            crossDomain: true,
            contentType: "application/json; charset=utf-8",
            success: function(data) {
                self.myReservations=data
                self.tempReservations=data
                self.loading = false
                
            },
            error: function(data, status, error) {
            }
        })
        }
        
    },
    computed :{
       summaryComp: function(){
            if (this.summaryCollapse==true)
                return 'Hide filters and sort'
            else 
                return 'Show filters and sort'
    },
    sortedReservationsComp: function() {
        var self = this
        function start(a, b) {
        if (a.StartDate < b.StartDate)
            return -1;
        if (a.StartDate > b.StartDate)
            return 1;
        return 0;
        }

        function submitted(a, b) {
        if (a.SubmittedDate > b.SubmittedDate)
            return -1;
        if (a.SubmittedDate < b.SubmittedDate)
            return 1;
        return 0;
        }

        function price(a, b) {
        if (a.TotalPrice > b.TotalPrice)
            return -1;
        if (a.TotalPrice < b.TotalPrice)
            return 1;
        return 0;
        }

        if (self.sort==0)            
            self.myReservations.sort(submitted);
        else if (self.sort==1)
            self.myReservations.sort(start)
        else if (self.sort==2)
            self.myReservations.sort(price)
        
        return self.myReservations
    },
     currencyComp: function(){
            return store.getters.CountryData.Currency
        },
    },
    mounted: function(){
       var self =this;
       this.$ga.page(this.$router)
       self.loadData();
       this.refreshInterval = setInterval(function (){
           self.loadData();
       }, 360000)
    
            
    },
    updated: function(){
        
    },
    beforeDestroy: function(){
        clearInterval(this.refreshInterval)
        
    },
 
    
}

</script>


<style scoped>


.reservationSummary{
    border: 1px;
    padding:10px;
    border-style: solid;
    border-color:#c3c3c3;
    border-radius: 5px;
    background: whitesmoke;
}

.reservation-box{
    border: #d5d5d8;
    border-style: solid;
    border-radius: 5px;
    margin-top:10px;
   
    padding-bottom: 15px;
}


.wrapper{
         border:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    padding: 10px;
    margin-top:5px;
    margin-bottom:19px;

}

label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: normal;
}


.filters{
  background-color:#e5e5e5;
  padding:20px;
  margin:5px;
  border-radius:5px;
  border-style:solid;
  border: 1px;
  border-color: red;
}
</style>


// WEBPACK FOOTER //
// CustomerConfirmedReservations.vue?0003e3e5